import { ReactNode } from 'react';

import { UIChatMessage } from '../chat.types';
import { useChatUserMessage, messageRegistry } from '~/components/Chat/ChatUserMessage/ChatUserMessage.utils';

export type ChatUserMessageProps<Message extends UIChatMessage = UIChatMessage> = {
  message: Message;
};

export const ChatUserMessage = ({ message }: ChatUserMessageProps): ReactNode => {
  const { variant } = useChatUserMessage(message);

  // Get the component from registry and render it
  const Component = messageRegistry[variant];
  return <Component message={message} />;
};
